import {
  tierOptions,
  paymentMethodOptions,
  providerOptions,
} from "@/features/license-fee/list/utils/license-fee-mappings";

export const loader = async () => {
  return {
    tierOptions,
    paymentMethodOptions,
    providerOptions,
    defaultValues: {},
  };
};

export type LoaderData = Awaited<ReturnType<typeof loader>>;
